import { render, staticRenderFns } from "./ClientAddPopUp.vue?vue&type=template&id=bf5d2eb8&scoped=true&"
import script from "./ClientAddPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientAddPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddPopUp.vue?vue&type=style&index=0&id=bf5d2eb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5d2eb8",
  null
  
)

export default component.exports